import arrayMutators from 'final-form-arrays'
import { Button } from "primereact/button"
import { Checkbox } from "primereact/checkbox"
import { Chips } from "primereact/chips"
import { Dropdown } from "primereact/dropdown"
import { Fieldset } from 'primereact/fieldset'
import { InputText } from "primereact/inputtext"
import { classNames } from "primereact/utils"
import { Tooltip } from 'primereact/tooltip';
import { useState } from "react"
import { Field, Form } from "react-final-form"
import { FieldArray } from 'react-final-form-arrays'
import { AmazonLexInbuiltSlotType, ConfirmationSetting, DelegatedQuestion,
   IntentDetails, InterviewNode, QuestionType } from "../../../../../../CandidatePortal/scenes/Interview/Chatbot/interface"
import { useDispatch } from 'react-redux'
import { AppDispatch } from '../../../../../../store'

import OnChange from "../../../../../../utils/OnChange"
import styles from "../styles.module.css"

interface DelegatedFormProps {
  actionOnSubmit: any
  actionOnDelete: any
  intentNode: DelegatedQuestion
  firstNode: InterviewNode
  lastNode:InterviewNode
  intentNameList?: string[]
  isUpdate?: boolean
  autosave: boolean
  onQuestionTypeChange: (newQuestionType: any) => void
}

const DelegatedForm = (props: DelegatedFormProps) => {
  const { actionOnSubmit, actionOnDelete, intentNode, firstNode, lastNode, intentNameList, isUpdate = false, autosave, onQuestionTypeChange } = props
  // const [chips, setChips] = useState<string[]>(intentNode.chips ? intentNode.chips : [])

  const dispatch = useDispatch<AppDispatch>()

  const allSlotKeys = Object.keys(AmazonLexInbuiltSlotType) as string[]
  const allSlotValues = Object.values(AmazonLexInbuiltSlotType) as string[]
  const allTenantSlotTypeOptions = [
    {
      label: "Default Types",
      items: allSlotKeys.map((value: string, index: number) => {
        return { label: value, value: allSlotValues[index] }
      })
    }
  ]

  // const remapSlotTypeValueToKey = (slotTypeValue: string) => {
  //   if (slotTypeValue !== undefined && slotTypeValue.length > 0) {
  //     const allInBuiltSlotValues = Object.values(AmazonLexInbuiltSlotType) as string[]
  //     const index = allInBuiltSlotValues.indexOf(slotTypeValue)
  //     if (index !== -1) { //Is an in-built slot type value, map back to in-built enum key
  //       return Object.keys(AmazonLexInbuiltSlotType)[index]
  //     }
  //   }
  //   return slotTypeValue
  // }

  const groupedItemTemplate = (option: any) => {
    return (
      <div className="text-lg font-bold text-blue-600">{option.label}</div>
    );
  }

  //Mutating initialValues from enum value (for backend use) to enum key representation for dropdown options UI
  let initialValues: DelegatedQuestion = !!intentNode ? { ...intentNode, } : {} as DelegatedQuestion

  // let tempValues = { ...initialValues }
  // if (tempValues.slotElicitationSetting && Object.keys(tempValues.slotElicitationSetting).length > 0) {
  //   let slotTypeEnumKey = remapSlotTypeValueToKey(tempValues.slotElicitationSetting?.slotType)
  //   tempValues.slotElicitationSetting.slotType = slotTypeEnumKey; //Mutating
  // }
  // initialValues = { ...tempValues }

  const validate = (data: any) => {
    let errors = {} as any

    if (!data.typeOfQuestion) {
      errors.typeOfQuestion = 'The type of question must be specified'
    }

    if (!data.name) {
      errors.name = 'Please specify the name of the node'
    } else if (!isUpdate && data.name) {
      if (intentNameList && intentNameList.length > 0 && intentNameList.find(element => element === data.name) !== undefined) {
        errors.name = 'This name is currently in use by another node'
      }
    }

    // if (!data.slotName) {
    //   errors.slotName = 'Please specify a slot name'
    // }
    
    if (data.isFirstQuestion && Object.keys(firstNode).length !== 0 && !initialValues.isFirstQuestion)
        errors.isFirstQuestion = "First node already exists"
    if (data.isLastQuestion && Object.keys(lastNode).length !== 0  && !initialValues.isLastQuestion)
        errors.isLastQuestion = "Last node already exists"

    if (!data.slotType) {
      errors.slotType = 'Please select a slot type'
    }

    if (data.slotPrompt === undefined || data.slotPrompt.length === 0) {
      errors.questionPrompts = "Please input a prompt."
    }

    return errors;
  }

  const onSubmit = (data: any, form: any) => {
    let payload = {} as InterviewNode
    payload = data
    payload.position = data.position ? data.position : { x: 0, y: 0 }
    console.log(payload)

    dispatch(actionOnSubmit(payload, autosave))
    form.restart()
  }

  const deleteNode = (form: any) => {
    dispatch(actionOnDelete(initialValues, autosave))
    form.restart()
  }

  const getExcludedNameList = (values: any) => {
    if (!!values) {
      let tempIntentNameList = intentNameList?.slice(0)
      if (tempIntentNameList) {
        let valueIndex = tempIntentNameList.indexOf(values)
        if (valueIndex !== -1)
          tempIntentNameList.splice(valueIndex, 1)
      }
      return tempIntentNameList
    }
    return intentNameList
  }

  const required = (value: any) => value ? undefined : 'This is a required field'

  const checkForDuplicate = (value: string[]) => {
    if (value && value.length > 0) {
      let tempArr = value.map(element => element.toLowerCase())
      if (new Set(tempArr).size !== value.length)
        return 'Please check if there are any duplicated chip values';
      return undefined;
    }
    return undefined;
  }

  const isFormFieldValid = (meta: any) => !!((meta.touched || meta.modified) && meta.error)
  const getFormErrorMessage = (meta: any) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>
  }

  const WhenLastQuestionIsChecked = ({ set, to }: { set: string, to: any }) => {
    return (
      <Field name={set} subscription={{}}>
        {(
          // No subscription. We only use Field to get to the change function
          { input: { onChange } }
        ) => {
          return (
            <OnChange name='isLastQuestion'>
              {(value: boolean) => {
                if (value === true) {
                  onChange(to);
                }
              }}
            </OnChange>
          )
        }}
      </Field>
    )
  }

  return (
    <div>
      <h3>{isUpdate ? "Update new Delegated node" : "Create new Delegated node"}</h3>
      <p className="text-sm font-italic font-normal line-height-3 text-500 hover:text-700">
        A Delegated node type is intended to capture a particular response from a user given a specific domain.
        <br></br>
        This domain is not explicitly provided, but instead, interpreted from a given set of example responses.
        <br></br>
        Such as a Delegated node type to capture preferred programming language of a candidate would be given a set of examples: "Java, JavaScript, C++".
      </p>
      <p className="text-xs font-italic font-normal line-height-3 text-500 hover:text-700">
        *Note that chips are important for this node type to aid candidates in their response and to narrow down the kind of response they should give.
      </p>
      <Form onSubmit={onSubmit} mutators={{ ...arrayMutators }} initialValues={initialValues} validate={validate} render={({ form: { mutators: { push, pop, remove } }, form, values, handleSubmit, pristine }) => (
        <form onSubmit={handleSubmit}>
          <WhenLastQuestionIsChecked set="confirmationSetting.flowToIfYes" to={undefined} />
          <WhenLastQuestionIsChecked set="nextStep" to={undefined} />
          <Fieldset className={styles.nodeform} legend="Node Details" toggleable>
            <div className="formgrid grid">
              <Field name="typeOfQuestion" render={({ input, meta }) => (
                <div className="field col-6 md:col-6">
                  <label htmlFor="typeOfQuestionInput" className={classNames({ 'p-error': isFormFieldValid(meta) })}>Type of Question*</label>
                  <Dropdown id="typeOfQuestionInput" {...input} disabled={isUpdate} options={Object.values(QuestionType)} onChange={onQuestionTypeChange} className={classNames("inputfield w-full", { 'p-invalid': isFormFieldValid(meta) })} />
                  {getFormErrorMessage(meta)}
                </div>
              )} />
              <Field name="name" render={({ input, meta }) => (
                <div className="field col-6 md:col-6">
                  <label htmlFor="nameInput" className={classNames({ 'p-error': isFormFieldValid(meta) })}>Name of Node*</label>
                  <InputText id="nameInput" autoComplete="off" {...input} inputMode="text" className={classNames("inputfield w-full", { 'p-invalid': isFormFieldValid(meta) })} />
                  {getFormErrorMessage(meta)}
                </div>
              )} />
              <Field name="chips" validate={checkForDuplicate} render={({ input, meta }) => (
                <div className="field col-12">
                  <label htmlFor="chipsInput">Chips</label>
                  <Chips id="chipsInput" {...input} allowDuplicate={false} separator="," className={classNames("inputfield w-full", { 'p-invalid': isFormFieldValid(meta) })} />
                  {getFormErrorMessage(meta)}
                </div>
              )} />
              <Field name="multipleValues" type="checkbox" render={({ input }) => (
                <div className="field-checkbox col-12 md:col-6">
                  <Checkbox inputId="multipleValuesInput" {...input} checked={input.checked || false} />
                  <label htmlFor="multipleValuesInput">Allow multiple inputs?</label>
                </div>
              )} />
              <Field name="isFirstQuestion" type="checkbox" render={({ input, meta }) => (
                <div className="field-checkbox field col-12 md:col-6">
                  <Checkbox inputId="isFirstQuestionInput" {...input} checked={input.checked || false} />
                  <label htmlFor="isFirstQuestionInput">Is this node the first question of the interview?</label>
                  {getFormErrorMessage(meta)}
                </div>
              )} />
              <Field name="isLastQuestion" type="checkbox" render={({ input, meta }) => (
                <div className="field-checkbox field col-12 md:col-6">
                  <Checkbox inputId="isLastQuestionInput" {...input} checked={input.checked || false} />
                  <label htmlFor="isLastQuestionInput">Is this node the last question of the interview?</label>
                  {getFormErrorMessage(meta)}
                </div>
              )} />
            </div>
          </Fieldset>

          <Fieldset className={styles.nodeform} legend="Elicitation Settings" toggleable>
            <div className="formgrid grid">
              {/* <Field name="slotName" render={({ input, meta }) => (
                <div className="field col-6">
                  <label htmlFor="slotNameInput" className={classNames({ 'p-error': isFormFieldValid(meta) })}>Slot Name*</label>
                  <InputText id="slotNameInput" autoComplete="off" {...input} inputMode="text" className={classNames("inputfield w-full", { 'p-invalid': isFormFieldValid(meta) })} />
                  {getFormErrorMessage(meta)}
                </div>
              )} /> */}
              
              <Field name="slotPrompt" render={({ input, meta }) => (
                <div className="field col-12">
                  <label htmlFor="slotPromptInput" className={classNames({ 'p-error': isFormFieldValid(meta) })}>Slot Prompt*</label>
                  <InputText id="slotPromptInput" {...input} inputMode="text" className={classNames("inputfield w-full", { 'p-invalid': isFormFieldValid(meta) })} />
                  {getFormErrorMessage(meta)}
                </div>
              )} />
              <Field name="slotType" render={({ input, meta }) => (
                <div className="field col-7">
                  <label htmlFor="slotTypeInput" className={classNames({ 'p-error': isFormFieldValid(meta) })}>Slot Type*</label>
                  <Dropdown id="slotTypeInput" {...input} options={allTenantSlotTypeOptions} className={classNames("inputfield w-full", { 'p-invalid': isFormFieldValid(meta) })} optionGroupChildren="items" optionGroupLabel="label" optionGroupTemplate={groupedItemTemplate} />
                  {getFormErrorMessage(meta)}
                </div>
              )} />
              <Field name="nextStep" render={({ input }) => (
                  <div className="col-12">
                    <div className="field col-12">
                      <label htmlFor="nextStepInput">Next Step</label>
                      <Dropdown id="nextStepInput" showClear disabled={values.isLastQuestion} tooltip="The next node to flow to if confirmed" {...input} options={!!intentNameList ? getExcludedNameList(values.name) : []} className="inputfield w-full" />
                    </div>
                  </div>
                )} />
            </div>
          </Fieldset>
          <div className="flex justify-content-end align-items-end mt-2">
            <Button type="button" className="p-button-outlined p-button-danger mr-3" label="Delete" icon="pi pi-trash" onClick={() => deleteNode(form)} disabled={!isUpdate}></Button>
            <Button type="submit" label={isUpdate ? "Update" : "Create"} icon="pi pi-check" disabled={pristine}></Button>
          </div>
        </form>
      )
      } />
    </div >
  )
}

export default DelegatedForm